<template>
  <div class="channel-flow-success-container">
    <!-- Confetes -->
    <div class="channel-flow-confetti-container">
      <div v-for="n in 50" :key="n" class="channel-flow-confetti" :style="{ '--delay': `${Math.random() * 5}s`, '--left': `${Math.random() * 100}%` }"></div>
    </div>

    <!-- Ícone de sucesso -->
    <div class="channel-flow-icon-container">
      <svg class="channel-flow-checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
        <circle class="channel-flow-checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
        <path class="channel-flow-checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
      </svg>
    </div>

    <!-- Título e descrição -->
    <h2 class="channel-flow-title channel-flow-animated-bounce">{{getTranslations("expression_1373")}}</h2>
    <p class="channel-flow-descricao  channel-flow-animated-fade-in">
      {{getTranslations("expression_1374")}}
    </p>

    <!-- Botão de Fechar -->
    <button class="channel-flow-btn-close animated-pulse" @click="closeModal">{{getTranslations("expression_1375")}}</button>

    <!-- Som de sucesso -->
    <!-- <audio ref="successSound" src="/success-sound.mp3" autoplay></audio> -->
  </div>
</template>


<script>
import "../../../../js/assets/css/Channel-Flow/channel-flow.css"
export default {
  methods: {
    closeModal() {
      this.$emit("close");
    }
  },
  mounted() {
   
    // this.$refs.successSound.play().catch(() => console.warn("Autoplay bloqueado pelo navegador."));
  }
};
</script>

<!-- <style scoped>
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@300;400;500;600&display=swap');

* {
  font-family: 'Manrope', sans-serif;
}

.channel-flow-success-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  text-align: center;
  background-color: #ffffff;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
}

/* 🎊 Confetes 🎊 */
.channel-flow-confetti-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.channel-flow-confetti {
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: hsl(calc(var(--left) * 3.6), 80%, 60%);
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  animation: channel-flow-confetti-fall 3s linear infinite;
  animation-delay: var(--delay);
  left: var(--left);
}

@keyframes channel-flow-confetti-fall {
  0% {
    transform: translateY(-100%) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(100vh) rotate(720deg);
    opacity: 0;
  }
}

/* ✅ Ícone de Sucesso ✅ */
.channel-flow-icon-container {
  margin-bottom: 1rem;
  z-index: 1;
}

/* Checkmark animation */
.channel-flow-checkmark__circle {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 2;
  stroke-miterlimit: 10;
  stroke: #7ac142;
  fill: none;
  animation: channel-flow-stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.channel-flow-checkmark {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: block;
  stroke-width: 2;
  stroke: #fff;
  stroke-miterlimit: 10;
  margin: 10% auto;
  box-shadow: inset 0px 0px 0px #7ac142;
  animation: channel-flow-fill .4s ease-in-out .4s forwards, channel-flow-scale .3s ease-in-out .9s both;
}

.channel-flow-checkmark__check {
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: channel-flow-stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

@keyframes channel-flow-stroke {
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes channel-flow-scale {
  0%, 100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
}

@keyframes channel-flow-fill {
  100% {
    box-shadow: inset 0px 0px 0px 30px #7ac142;
  }
}

/* 🎉 Texto Celebrativo 🎉 */
.channel-flow-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 1rem;
  z-index: 1;
}

.channel-flow-descricao {
  font-size: 0.95rem;
  color: #4a5568;
  margin-bottom: 1.5rem;
  max-width: 80%;
  z-index: 1;
}

/* 🎊 Animações extras 🎊 */
.channel-flow-animated-bounce {
  animation: channel-flow-bounce 1.5s infinite;
}

.channel-flow-animated-fade-in {
  animation: channel-flow-fade-in 1s ease-in-out;
}

.channel-flow-animated-pulse {
  animation: channel-flow-pulse 1s infinite;
}

@keyframes channel-flow-bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

@keyframes channel-flow-fade-in {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes channel-flow-pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

/* 🎯 Botão de Fechar com Pulso 🎯 */
.channel-flow-btn-close {
  padding: 0.5rem 1rem;
  background-color: #1a202c;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: background 0.2s ease-in-out, transform 0.1s ease-in-out;
  z-index: 1;
}

.channel-flow-btn-close:hover {
  background-color: #2d3748;
}

.channel-flow-btn-close:active {
  transform: scale(0.98);
}


</style> -->
